/**
* @ngdoc directive
* @name Settings Selector
*
* @description
  Ellipsis selector that shows:
  * a block of options on click on desktop
  * a fullscreen block of options on mobile
  check code samples for markup required
*
* @transclude
  template with options, every first option should be wrapped in div with 'custom-selector__option' class
*
* @example
  <settings-selector>
    <div class="custom-selector__option">
      <button  type="button" class="btn btn-primary-panel btn-settings-action" ng-click="alert()">
        <span class="btn-settings-action__icon icon-add"></span>
        <span class="btn-settings-action__caption">Alert</span>
      </button>
    </div>
    <div class="custom-selector__option">
      <export-to-excel class="btn-settings-action"></export-to-excel>
    </div>

    <div class="custom-selector__option">
      <export-to-pdf class="btn-settings-action"></export-to-pdf>
    </div>
  </settings-selector>
*/

(function() {
  'use strict';

  directive.$inject = ["PATH"];
  app.directive('settingsSelector', directive);

  function directive(PATH) {
    return {
      restrict: 'E',
      scope: {
        closeOnClick:'=',
        vertical:'='
      },
      transclude: true,
      templateUrl: PATH.components + 'settingsSelector/template.html',
      controller: 'CustomSelectorController'
    };
  }
})();



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/settingsSelector/directive.js